module.exports = __webpack_public_path__ + "img/beech.c8b634f.svg";